export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    }
  }
}